import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserManager } from 'oidc-client-ts';
import { useUser } from '../contexts/UserContext';
import { useTenant } from '../contexts/TenantContext';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import './OidcCallbackCommon.css'; // Import the CSS file for animations

const OidcCallbackTenant = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { fetchUserData, loadingUser, userData } = useUser();
  const { loadingTenant, tenantData } = useTenant();
  const [redirected, setRedirected] = useState(false); // Track if navigation has occurred

  useEffect(() => {
    // Protection anti-double appel (StrictMode ou double mount)
    const code = new URLSearchParams(window.location.search).get('code');
    if (!code) return; // Pas de code, rien à faire
    const codeFlag = `oidc_code_consumed_${code}`;
    if (sessionStorage.getItem(codeFlag)) {
      // Ce code a déjà été traité, on ne refait rien
      return;
    }
    sessionStorage.setItem(codeFlag, '1');

    // Retrieve the selected OIDC configuration from sessionStorage
    const storedConfig = sessionStorage.getItem('selectedOidcConfig');
    if (!storedConfig) {
      console.error('No OIDC configuration found in sessionStorage.');
      navigate('/login', { replace: true });
      return;
    }

    const oidcConfig = JSON.parse(storedConfig);
    const dynamicUserManager = new UserManager(oidcConfig);

    dynamicUserManager.signinRedirectCallback().then(async user => {
      let idToken = user?.id_token;
      if (!idToken) {
        const storageKey = `oidc.user:${dynamicUserManager.settings.authority}:${dynamicUserManager.settings.client_id}`;
        const stored = sessionStorage.getItem(storageKey);
        if (stored) {
          try {
            const parsed = JSON.parse(stored);
            idToken = parsed.id_token;
          } catch {}
        }
      }
      if (idToken) {
        localStorage.setItem('access_token', idToken);
        window.dispatchEvent(new Event('tokenChanged'));
        await fetchUserData(); // Ensure user data is fetched after token is set
      } else {
        navigate('/login', { replace: true });
      }
    }).catch(() => {
      navigate('/login', { replace: true });
    });
    // eslint-disable-next-line
  }, [navigate, fetchUserData]);

  useEffect(() => {
    // Debug logs pour comprendre le flow
    console.log('[OIDC CALLBACK] loadingUser:', loadingUser, 'userData:', userData, 'tenantData:', tenantData);

    if (!redirected && !loadingUser && userData && tenantData) {
      console.log('[OIDC CALLBACK] Navigation vers /dashboard avec subdomain_prefix:', tenantData.subdomain_prefix);
      setRedirected(true); // Ensure navigation happens only once
      navigate(`/app/${tenantData.subdomain_prefix}/dashboard`, { replace: true });
    } else {
      console.log('[OIDC CALLBACK] En attente de userData ou de la fin de loadingUser:', {
        loadingUser,
        userData,
        tenantData,
      });
    }
  }, [loadingUser, userData, tenantData, navigate, redirected]);

  return (
    <div>
        <Box sx={{ py: 2,textAlign: 'center', mb: 2 }}>
            <Typography sx={{ variant: "h6", gutterBottom: true, pt: 8 }}>  </Typography>
            <img
                // src="/logo_banane_transparent.png"
                src="/animation_loading.gif"
                alt={t('login.logoAlt')}
                className="login-logo-image rotate-animation" // Added animation class
                style={{ height: '60px' }} // Adjust size as needed
            />
            <Typography sx={{ variant: "h6", gutterBottom: true, pt: 8 }}>
                {t('login.processing')}
            </Typography>
        </Box>
        
    </div>
  );
};

export default OidcCallbackTenant;